import React from 'react';

interface IProps {
  style?: any;
  stroke?: string;
}

const HiddenIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="15" height="6" viewBox="0 0 15 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
      <path d="M12.7239 1C12.7239 1.31902 10.3675 3.55215 7.4601 3.55215C4.55304 3.55215 2.19629 1.31902 2.19629 1" stroke={props.stroke??"#667080"} strokeOpacity="0.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M2.19632 1L1 2.03681" stroke={props.stroke??"#667080"} strokeOpacity="0.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M3.31318 2.27734L2.27637 3.47367" stroke={props.stroke??"#667080"} strokeOpacity="0.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M5.06773 3.07422L4.19043 4.43005" stroke={props.stroke??"#667080"} strokeOpacity="0.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M12.8037 1L14 2.03681" stroke={props.stroke??"#667080"} strokeOpacity="0.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M11.6875 2.27734L12.7243 3.47367" stroke={props.stroke??"#667080"} strokeOpacity="0.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M9.93262 3.07422L10.8099 4.43005" stroke={props.stroke??"#667080"} strokeOpacity="0.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M6.74187 3.55469L6.42285 5.14978" stroke={props.stroke??"#667080"} strokeOpacity="0.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M8.33789 3.55469L8.65691 5.14978" stroke={props.stroke??"#667080"} strokeOpacity="0.5" strokeMiterlimit="10" strokeLinecap="round"/>
    </svg>
  )
}

export default HiddenIcon;